import { defineMessages } from 'react-intl'

const messages = defineMessages({
  youWontPay: {
    id: 'reservation.free-cancellation',
  },
  canNotBeCancelled: {
    id: 'reservation.cannot-be-cancelled',
  },
  partialRefundDesc: {
    id: 'global.cancellation-policies-refundable',
  },
  cancelWithRefund: {
    id: 'reservation.cancel-with-refund',
  },
  NRF: {
    id: 'reservation.no-refundable',
  },
  SFL: {
    id: 'global.partial-refund',
  },
  NOR: {
    id: 'global.free-cancellation',
  },
})

export default messages
